import React, {Component} from 'react';
import styles from "./record.module.css";
import {FILE_URL} from "../../../util/constants";
import icDelete from "../../../img/delete.png";
import closeIcon from "../../../img/bt-close.png";
import defaultIcon from "../../../img/bee.png";
import MyImg from "../../myimg/myimg.jsx";

const Record = props => (
    <div className={styles["modal-overlay"]}>
        <div className={styles["modal-content"]}>
            <div className={styles.titlebar}>
                <div className={styles["text-name"]}>
                    学生评价记录
                </div>

                <img
                    className={styles.close}
                    src={closeIcon}
                    onClick={props.onRequestClose}
                />
            </div>

            <div className={styles.list} >
                {
                    props.recordList.length > 0 ? (
                            <React.Fragment>
                                {
                                    props.recordList.map((item, index, array) => {
                                        return (
                                            <div className={styles['list-item']}>

                                                <img
                                                    className={styles['list-item-touxiang']}
                                                    src={item.student_pic }
                                                    onError={props.handleImageErrored.bind(this,index)}
                                                />
                                                {/*<MyImg type='record' src={item.student_pic}/>*/}

                                                <div className={styles['div-name']}>
                                                    <div className={styles['item-name']}>{item.student_name}</div>
                                                    <div className={styles['item-date']}>{item.dongtai_time}</div>
                                                </div>

                                                {/*<div className={styles['list-div-img']}>*/}
                                                    {/*<img*/}
                                                        {/*className={styles.img}*/}
                                                        {/*src={FILE_URL+item.dongtai_pic}*/}
                                                    {/*/>*/}
                                                {/*</div>*/}

                                                <div className={styles['item-title']}>{item.dongtai_title}</div>

                                                {/*<div className={item.biaozhun_type=='1'?styles['text-num-blue'] :styles['text-num-red']}>{item.biaozhun_type=='1'?'+':'-'}1</div>*/}

                                                <div className={styles['text-num-green']} >+1</div>


                                                <img className={styles['img-delete']} src={icDelete}
                                                     onClick={props.deleteRecord.bind(null,item)}/>

                                            </div>
                                        );
                                    })
                                }
                            </React.Fragment>
                        )
                        : (<div className={styles['no-data']}>暂无记录</div>)
                }

            </div>


        </div>
    </div>
)

export default Record;
